const associationTypeToIso = {
    "IsCitedBy": "crossReference",
    "Cites": "crossReference",
    "IsSupplementTo": "crossReference",
    "IsSupplementedBy": "crossReference",
    "IsContinuedBy": "series",
    "Continues": "series",
    "IsDescribedBy": "crossReference",
    "Describes": "crossReference",
    "HasMetadata": "crossReference",
    "IsMetadataFor": "crossReference",
    "HasVersion": "revisionOf",
    "IsVersionOf": "revisionOf",
    "IsNewVersionOf": "revisionOf",
    "IsPreviousVersionOf": "crossReference",
    "IsPartOf": "largerWorkCitation",
    "HasPart": "isComposedOf",
    "IsPublishedIn": "largerWorkCitation",
    "IsReferencedBy": "crossReference",
    "References": "crossReference",
    "IsDocumentedBy": "crossReference",
    "Documents": "crossReference",
    "IsCompiledBy": "dependency",
    "Compiles": "dependency",
    "IsVariantFormOf": "crossReference",
    "IsOriginalFormOf": "crossReference",
    "IsIdenticalTo": "crossReference",
    "IsReviewedBy": "crossReference",
    "Reviews": "crossReference",
    "IsDerivedFrom": "dependency",
    "IsSourceOf": "dependency",
    "Requires": "dependency",
    "IsRequiredBy": "dependency",
    "IsObsoletedBy": "crossReference",
    "Obsoletes": "revisionOf",
};

export default associationTypeToIso;